module.exports = __webpack_public_path__ + "ceb4bc6df1e730d2f3f3612d912f68cf.svg";